import { Context } from "src/app/shared/services/context.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Platform } from "@ionic/angular";
import { Injectable } from "@angular/core";
import { DiagDiagnostic } from "../model/diagDiagnostic.model";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "false" }),
};
@Injectable({
  providedIn: "root",
})
export class DiagDiagnosticService {
  constructor(private http: HttpClient, public platform: Platform) {}
  getFamilleTraitements(idPatient) {
    return this.http.get<DiagDiagnostic[]>(
      Context.apiUrl + "getResumesCliniqueByPatient/" + idPatient
    );
  }
  getFamilleTraitementsArch(idPatient) {
    return this.http.get<DiagDiagnostic[]>(
      Context.apiUrl + "getResumesCliniqueByPatientNotArch/" + idPatient
    );
  }
  getDiagnostic(idDiag){
    return this.http.get<DiagDiagnostic[]>(
      Context.apiUrl + "getResumesCliniqueById/" + idDiag
    );
  }
  getDiagnostiques(idPatient){
    return this.http.get<DiagDiagnostic[]>(Context.apiUrl + "getResumesCliniqueByPatients/"+ idPatient)
  }
  addNewDiagnostic(diag){
    return this.http.post(Context.apiUrl + 'diagDiagnostic/insert',diag);
  }
  addNewDiagnosticNotArch(diag){
    return this.http.post(Context.apiUrl + 'diagDiagnostic/insertNotarchir',diag);
  }
  updateDiagAnalyse1(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse1/'+id,diag);
  }
  updateDiagAnalyse1EtageInf(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse1etageinfer/'+id,diag);
  }
  updateDiagAnalyse2(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse2/'+id,diag);
  }
  updateTnldroit(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateTnldroit/'+id,diag);
  }
  updateTnlgauche(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateTnlgauche/'+id,diag);
  }
  updateTnl(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateTnl/'+id,diag);
  }
  updateSouriredentaire(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateSouriredentaire/'+id,diag);
  }
  updateDiagAnalyse3(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3/'+id,diag)
  }
  updateDiagAnalyse3canindroite(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3caninedroite/'+id,diag)
  }
  updateDiagAnalyse3caningauche(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3caninegauche/'+id,diag)
  }
  updateDiagAnalyse3occlusionface(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusionface/'+id,diag)
  }
  updateDiagAnalyse3occlusionvalue(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusionvalue/'+id,diag)
  }
  updateDiagAnalyse3occlusioninverse(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusioninverse/'+id,diag)
  }
  updateDiagAnalyse3occlusioninverseAnterieur(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateAnalyse3occlusioninverseAnterieur/'+id,diag)
  }
  updateOcclusalDeviationMilieux(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateOcclusalDeviationMilieux/'+id,diag)
  }
  updateDiagAnalyse3Basal(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusalBasal/'+id,diag)
  }
  updateDiagAnalyse3Alveolaire(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusalAlveolaire/'+id,diag)
  }
  updateDiagAnalyse3Fonctionnel(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse3occlusalFonctionnel/'+id,diag)
  }
  updateDiagAnalyse4RespBucc(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse4RespBucc/'+id,diag)
  }
  updateDiagAnalyse4InterpLingual(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse4InterpLingual/'+id,diag)
  }
  updateDiagAnalyse4diagfonc(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalyse4diagfonc/'+id,diag)
  }
  updateDiagAnalyseArcadeForm(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeForm/'+id,diag)
  }
  updateDiagAnalyseArcadeFormBas(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeFormBas/'+id,diag)
  }
  updateDiagAnalyseArcadeFormLyre(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeFormLyre/'+id,diag)
  }
  updateDiagAnalyseArcadeDivers(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateanalysearcadedivers/'+id,diag);
  }
  updateDiagAnalyseArcadeSurplomb(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadesurplomb/' + id,diag)
  }
  updateAnalyseSourireSup(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysesouriresup/' + id,diag)
  }
  updateAnalyseSourireInf(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysesourireinf/' + id , diag)
  }
  updateAnalyseSourireLabial(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysesourireLabial/' + id , diag)
  }
  updateAnalyseProfilLevreSup(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateProfilLevreSup/' + id , diag)
  }
  updateAnalyseProfilLevreInf(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateProfilLevreInf/' + id , diag)
  }
  updateAnalyseProfilMenton(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateProfilMenton/' + id , diag)
  }
  updateAnalyseProfilIncisiveSup(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateProfilIncisiveSup/' + id , diag)
  }
  updateAnalyseProfilIncisiveInf(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateProfilIncisiveInf/' + id , diag)
  }
  updateAnalyseRadioSensRadioSagittal(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateRadioSensSagittal/'+ id, diag)
  }
  updateAnalyseRadioSensRadioSensVertical(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateRadioSensVertical/'+id , diag);
  }
  updateimgmasquefacial(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagmasquefacial/'+id , diag);
  }
  updateimgsourireface(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagsourireface/'+id , diag);
  }
  updateimgocclusaldroite(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagocclusaldroite/'+id , diag);
  }
  updateimgocclusalface(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagocclusalface/'+id , diag);
  }
  updateimgocclusalgauche(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagocclusalgauche/'+id , diag);
  }
  updateimgsourire(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagsourire/'+id , diag);
  }
  updateimgprofil(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagprofil/'+id , diag);
  }
  updateimgradio(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateimagradio/'+id , diag);
  }
  updateSyncro(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateSyncro/'+ id , diag);
  }
  archiverdiagnostique(id){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/archiver/'+id,null)
  }
  updateLangueBasse(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeLangueBasse/'+id,diag);
  }
  updateDDD(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDDD/'+id,diag);
  }
  updateDDDBas(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDDDbas/'+id,diag);
  }
  updateDDM(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDDM/'+id,diag);
  }
  updateDDMBas(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDDMbas/'+id,diag);
  }
  updateDiasteme(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDiasteme/'+id,diag);
  }
  updateDiastemeBas(id,diag){
    return this.http.put(Context.apiUrl + 'diagDiagnostic/updateanalysearcadeDiastemebas/'+id,diag);
  }
  updateFreinLabial(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateanalysearcadeFreinLabial/'+id,diag);
  }
  updateFreinLingual(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateanalysearcadeFrienLingual/'+id,diag);
  }
  UpdateDentControle(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsControle/'+id,diag);
  }
  UpdateDentAgenesie(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/UpdateDentAgenesie/'+id,diag);
  }
  updateDentsIncluses(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsIncluses/'+id,diag);
  }
  updateDentsSumm(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsSumm/'+id,diag);
  }
  updateSynchro(id, syncro_x, syncro_y, syncro__x, syncro__y, syncro_zoom, syncro_rotation) {
    return this.http.put(Context.apiUrl+`diagDiagnostic/updateSynchro/${id}/${syncro_x}/${syncro_y}/${syncro__x}/${syncro__y}/${syncro_zoom}/${syncro_rotation}`, null);
  }
  getDiagById(id) {
    return this.http.get<DiagDiagnostic>(Context.apiUrl+`diagDiagnostic/getDiagById/${id}`);
  }
  updateDentsAbsentes(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsAbsentes/'+id,diag);
  }
  updateDentscouronnes(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentscouronnes/'+id,diag);
  }
  updateDentsimplant(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsimplant/'+id,diag);
  }
  updateIncisiveMaxi(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateIncisiveMaxi/'+id,diag);
  }
  updateIncisiveMan(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateIncisiveMan/'+id,diag);
  }
  updateAlveoMax(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateAlveoMax/'+id,diag);
  }
  updateAlveoMan(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateAlveoMan/'+id,diag);
  }
  updateDentsManque(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsManquePlace/'+id,diag);
  }
  updateDentsCarie(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateDentsCarie/'+id,diag);
  }
  updateOpacite(id,diag){
    return this.http.put(Context.apiUrl+'diagDiagnostic/updateopacite/'+id,diag);
  }
  getOpacite(id){
    return this.http.get(Context.apiUrl+'diagDiagnostic/getOpcaite/'+id);
  }

  updateDeviationMenton(id: any, diag: any) {
    return this.http.put(
      `${Context.apiUrl}diagDiagnostic/updateDeviationMenton/${id}`, 
      diag
    );
  }
  updateAsymetrieFacial(id: any, diag: any) {
    return this.http.put(
      `${Context.apiUrl}diagDiagnostic/updateAsymetrieFacial/${id}`, 
      diag
    );
  }
  updateMasqueFacialCal(id: any, diag: any) {
    return this.http.put(
      `${Context.apiUrl}diagDiagnostic/updateMasqueFacialCal/${id}`, 
      diag 
    );
  }
  updateFaceSourireCal(id: any, diag: any) {
    return this.http.put(
      `${Context.apiUrl}diagDiagnostic/updateFaceSourireCal/${id}`, 
      diag
    );
  }
}